import { render } from "./admin-users-department.vue?vue&type=template&id=4094a2c1"
import script from "./admin-users-department.vue?vue&type=script&lang=js"
export * from "./admin-users-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-users-department.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4094a2c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4094a2c1', __exports__)) {
    api.reload('4094a2c1', __exports__)
  }
  
  module.hot.accept("./admin-users-department.vue?vue&type=template&id=4094a2c1", () => {
    api.rerender('4094a2c1', render)
  })

}


export default __exports__